<template>
  <div :class="$style.root">
    <div
      v-if="name"
      :class="$style.name"
      :title="name"
    >
      {{ name }}
    </div>
    <a
      v-if="phone"
      :class="$style.phone"
      :href="`tel:${phone.value}`"
    >
      {{ phone.formatted }}
    </a>
    <div>
      <slot name="default" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DropdownUserInfo',
    props: {
      name: {
        type: String,
        default: null,
      },
      phone: {
        type: Object,
        default: null,
      },
      branch: {
        type: String,
        default: null,
      },
    },
  };
</script>

<style lang="scss" module>
  .root {
    @include borderX(none);
  }

  .name {
    margin-bottom: 2px;
  }

  .phone {
    text-decoration: underline!important;
    text-decoration-color: #0000003b!important;
    text-underline-offset: 4px;
    @include phoneLink;
  }
</style>
